/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs from 'dayjs';

import { FormValues, StructureType } from '../../../types/types';
import { findStructure } from '../../../utils/dataTypes';

export type ResultGroups = { [key: string]: { [key: string]: StructureType } };

export type Product = {
 Id: number;
 Name: string;
 Ext: string;
 ShortCode: string;
 ProductGroup: string;
 Percentage: number;
};

export function groupResultModalItems(
 structures: StructureType[],
): ResultGroups {
 const result: ResultGroups = {};

 function processStructure(
  structure: StructureType[],
  parentPath: string = '',
 ): void {
  structure.forEach((item) => {
   const currentPath = parentPath ? `${parentPath}.${item.Name}` : item.Name;
   const group = item.Group || ''; // Use empty string if no group is specified

   if (!result[group]) {
    result[group] = {};
   }

   // Handle inner structures recursively
   if (item.InnerStructure && item.InnerStructure.length > 0) {
    result[group][currentPath] = item;
    processStructure(item.InnerStructure, currentPath);
   } else {
    // Handle leaf nodes
    result[group][currentPath] = item;
   }
  });
 }

 processStructure(structures);
 return result;
}

export const mapFormToPatch = (
 type: 'create' | 'update',
 data: FormValues,
 result: FormValues,
 structure: StructureType[],
 changedFields: string[] | undefined,
) => {
 console.log('mapFormToPatch', data, result, changedFields);
 let operations: { [key: string]: any } = {};
 if (type === 'create') {
  Object.keys(data)?.forEach((key: string) => {
   const str = findStructure(structure, key.replace(/\[\d+\]/g, ''));
   if (['Laboratory', 'ResultProducts'].includes(key)) return;

   const currentField = (data as any)[key];
   if (currentField !== '' && typeof currentField !== 'undefined') {
    if (str?.Type === 'enum') {
     console.log('enum', currentField, str?.EnumValues);
     (operations as any)[key] = Object.keys(str?.EnumValues).find(
      (k) => str?.EnumValues[k] === currentField,
     );
    } else if (str?.Type === 'array') {
     (operations as any)[key] = currentField;
    } else if (currentField?.Id) {
     console.log('has id');
     (operations as any)[key] = { Id: currentField?.Id };
    } else if (str?.Type === 'datetime') {
     console.log('datetime', currentField);
     (operations as any)[key] = dayjs(currentField).format(
      'YYYY-MM-DDTHH:mm:ss.SSS',
     );
    } else {
     console.log('save else');
     (operations as any)[key] = currentField;
    }
    //   if (currentField?.Id !== undefined) {
    //    console.log('is not null', currentField?.Id);
    //    if (currentField.Id !== null) {
    //     (operations as any)[key] = { Id: currentField?.Id };
    //    }
    //   } else {
    //    console.log('key', key, currentField);
    //    (operations as any)[key] = currentField;
    //   }
   }
  });
 } else {
  operations = [];
  changedFields?.forEach((key: string) => {
   if (['Laboratory'].includes(key) || key.includes('ResultProducts')) return;

   const fixedKey = key.replace(/\[\d+\]/g, '');

   const str = findStructure(structure, fixedKey.replace(/\[\d+\]/g, ''));
   console.log('str', key, str);
   if (str?.Type === 'enum') {
    console.log(Object.keys(str?.EnumValues));
    operations.push({
     op: 'replace',
     path: `/${key.replace('.', '/')}`,
     value: Object.keys(str?.EnumValues).find(
      (k) => str?.EnumValues[k] === (data as any)[key],
     ),
    });
   } else if (str?.Type === 'array') {
    console.log('array', fixedKey, (data as any)[fixedKey], data as any);

    (data as any)[fixedKey].forEach((item: any, index: number) => {
     if (data[fixedKey][index]?.Id) {
      console.log('has id', data[fixedKey][index]?.Id);
      operations.push({
       op: 'replace',
       path: `/${fixedKey.replace('.', '/')}/${index}/Id`,
       value: data[fixedKey][index]?.Id,
      });
     } else {
      operations.push({
       op: 'create',
       path: `/${fixedKey.replace('.', '/')}/${index}`,
       value: item,
      });
     }
    });
   } else if ((data as any)[key]?.Id) {
    operations.push({
     op: 'replace',
     path: `/${key.replace('.', '/')}/Id`,
     value: (data as any)[key]?.Id,
    });
   } else if (str?.Type === 'datetime') {
    operations.push({
     op: 'replace',
     path: `/${key.replace('.', '/')}`,
     value: (dayjs((data as any)[key]) as any).format(
      'YYYY-MM-DDTHH:mm:ss.SSS',
     ),
    });
   } else {
    console.log('xxxxxxx else', key, (data as any)[key]);
    operations.push({
     op: 'replace',
     path: `/${key.replace('.', '/')}`,
     value: (data as any)[key],
    });
   }
  });

  // Create maps for easier lookup
  if (data.ResultProducts) {
   const productOperations: any[] = [];
   const currentDataMap = new Map(
    data.ResultProducts.map((item: Product) => [item.Id, item]),
   );
   const prevDataMap = new Map(
    result.ResultProducts.map((item: Product) => [item.Id, item]),
   );

   // Check for items to add or replace
   data.ResultProducts.forEach((item: Product) => {
    const prevItem = prevDataMap.get(item.Id) as Product;

    if (!prevItem) {
     // Item is new, add it
     productOperations.push({
      op: 'add',
      path: `/ResultProducts`,
      value: item.Id,
     });
     productOperations.push({
      op: 'replace',
      path: `/ResultProducts/${item.Id}/Percentage`,
      value: item.Percentage,
     });
    } else if (item.Percentage !== prevItem.Percentage) {
     productOperations.push({
      op: 'replace',
      path: `/ResultProducts/${item.Id}/Percentage`,
      value: item.Percentage,
     });
    }
   });

   // Check for items to remove (in prevData but not in data)
   result.ResultProducts.forEach((prevItem: Product) => {
    if (!currentDataMap.has(prevItem.Id)) {
     productOperations.push({
      op: 'remove',
      path: `/ResultProducts`,
      value: prevItem.Id,
     });
    }
   });

   operations.push(...productOperations);
  }
 }
 return operations;
};

export const mapArrayFormToPatch = (
 arrayKey: string,
 itemId: number,
 data: FormValues,
 itemData: FormValues,
 structure: StructureType[],
 changedFields: string[] | undefined,
) => {
 console.log('mapArrayFormToPatch', arrayKey, data, itemData, changedFields);
 let operations: { [key: string]: any } = {};
 if (itemId === -1) {
  Object.keys(data)?.forEach((key: string) => {
   const str = findStructure(structure, key.replace(/\[\d+\]/g, ''));
   if (['Laboratory', 'ResultProducts'].includes(key)) return;

   const currentField = (data as any)[key];
   if (currentField !== '' && typeof currentField !== 'undefined') {
    if (str?.Type === 'enum') {
     console.log('enum', currentField, str?.EnumValues);
     (operations as any)[key] = Object.keys(str?.EnumValues).find(
      (k) => str?.EnumValues[k] === currentField,
     );
    } else if (str?.Type === 'array') {
     (operations as any)[key] = currentField;
    } else if (currentField?.Id) {
     console.log('has id');
     (operations as any)[`${key}Id`] = currentField?.Id;
    } else if (str?.Type === 'datetime') {
     console.log('datetime', currentField);
     (operations as any)[key] = dayjs(currentField).format(
      'YYYY-MM-DDTHH:mm:ss.SSS',
     );
    } else {
     console.log('save else');
     (operations as any)[key] = currentField;
    }
    //   if (currentField?.Id !== undefined) {
    //    console.log('is not null', currentField?.Id);
    //    if (currentField.Id !== null) {
    //     (operations as any)[key] = { Id: currentField?.Id };
    //    }
    //   } else {
    //    console.log('key', key, currentField);
    //    (operations as any)[key] = currentField;
    //   }
   }
  });
  operations = [
   {
    op: 'add',
    path: `/${arrayKey}`,
    value: operations,
   },
  ];
 } else {
  operations = [];

  let arrayKeyFix = '';
  switch (arrayKey) {
   case 'Addresses':
    arrayKeyFix = 'Address';
    break;
   default:
    arrayKeyFix = arrayKey.slice(0, -1); // Product, Emais ...
  }
  const innerId = data[arrayKeyFix]?.Id;

  const currentArrayEl = itemData[arrayKey].find((i: any) => i.Id === itemId);
  const currentInnerId = currentArrayEl?.[arrayKeyFix]?.Id;

  changedFields?.forEach((key: string) => {
   if (key === arrayKeyFix && itemId !== innerId) {
    console.log('no sense');
    console.log(key, arrayKeyFix, itemId, innerId);
    operations.push({
     op: 'replace',
     path: `/${arrayKey}/${itemId}`,
     value: innerId,
    });
   } else {
    operations.push({
     op: 'replace',
     path: `/${arrayKey}/${currentInnerId || itemId}/${key}`,
     value: key === 'Id' ? data[key]?.Id : data[key],
    });
   }
  });
  console.log('operations', operations);
 }
 return operations;
};

export const mapArrayFormToPatchDelete = (arrayKey: string, itemId: number) => {
 console.log('mapArrayFormToPatchDelete', arrayKey);
 const operations = [
  {
   op: 'remove',
   path: `/${arrayKey}`,
   value: itemId,
  },
 ];
 return operations;
};
